import { useMemo } from "react";

import { useAppSelector } from "~/hooks/reduxHooks";
import useModuleEnabledMap from "~/hooks/useModuleEnabledMap";
import canShowAppInstalls from "~/pwa/installAppGate";
import { type InstallableApp } from "~/pwa/installableApps";
import resolveInstallTargets from "~/pwa/resolveInstallTargets";
import useInstallPrompt from "~/pwa/useInstallPrompt";
import useRootInstalled from "~/pwa/useRootInstalled";

interface InstallAppGate {
	canShowInstall: boolean;
	targets: InstallableApp[];
}

const useInstallAppGate = (): InstallAppGate => {
	const isWideScreen = useAppSelector((state) => state.layout.isWideScreen);
	const { canInstall } = useInstallPrompt();
	const rootInstalled = useRootInstalled();
	const enabledByKey = useModuleEnabledMap();

	const targets = useMemo(() => resolveInstallTargets({ enabledByKey, rootInstalled }), [enabledByKey, rootInstalled]);
	const canShowInstall = canShowAppInstalls({ canInstall, isWideScreen, targetCount: targets.length });

	return { canShowInstall, targets };
};

export type { InstallAppGate };
export default useInstallAppGate;
